import Product from './ProductSetup';

export default Product;
